import "./App.css";
import { BrowserRouter as Router} from "react-router-dom";
import Home from "./Components/Home";
// import About from "./Components/About";
// import Navigation from "./Components/Navigation";
import Footer from "./Components/Footer";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import the AOS CSS


function App() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <Router>
      <div className="App">
        
        <div className="content">
            {/* <Navigation /> */}
            <Home />
            {/* <About /> */}

        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
